import React from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from 'stores';
import { BeneficiariesState, setType } from 'stores/beneficiaries';

const BeneficiaryPageHeader = () => {
  const dispatch = useDispatch();
  const { type } = useSelector<IRootState, BeneficiariesState>(({ beneficiaries }) => beneficiaries);

  const handleChange = (_, newValue) => {
    dispatch(setType(newValue));
  };

  return (
    <Box sx={{ mb: '20px' }}>
      <Box
        sx={{
          bgcolor: '#F2F4F7',
          borderRadius: '12px',
          width: '80vw',
          padding: '8px 12px',
          mb: '20px',
          mx: 'auto',
        }}
      >
        <Tabs
          value={type}
          onChange={handleChange}
          aria-label="custom tabs example"
          TabIndicatorProps={{
            style: {
              display: 'none',
            },
          }}
          sx={{
            minHeight: '32px',
            width: '100%',
          }}
          variant="fullWidth"
        >
          <Tab
            label="Contraparte para o envio de recursos"
            value="envio"
            sx={{
              textTransform: 'none',
              fontWeight: type === 'envio' ? 'bold' : 'normal',
              color: type === 'envio' ? 'black' : '#92929D',
              bgcolor: type === 'envio' ? 'white' : 'transparent',
              borderRadius: '12px',
              minHeight: '32px',
              py: '8px',
              px: '12px',
              minWidth: 0,
              '&:hover': {
                bgcolor: type === 'envio' ? 'white' : '#E0E0E0',
              },
            }}
          />

          <Tab
            label="Contraparte para emissão de boleto"
            value="boleto"
            sx={{
              textTransform: 'none',
              fontWeight: type === 'boleto' ? 'bold' : 'normal',
              color: type === 'boleto' ? 'black' : '#92929D',
              bgcolor: type === 'boleto' ? 'white' : 'transparent',
              borderRadius: '12px',
              minHeight: '32px',
              py: '8px',
              px: '12px',
              minWidth: 0,
              '&:hover': {
                bgcolor: type === 'boleto' ? 'white' : '#E0E0E0',
              },
            }}
          />

          <Tab
            label="Conta de minha titularidade"
            value="titularidade"
            sx={{
              textTransform: 'none',
              fontWeight: type === 'titularidade' ? 'bold' : 'normal',
              color: type === 'titularidade' ? 'black' : '#92929D',
              bgcolor: type === 'titularidade' ? 'white' : 'transparent',
              borderRadius: '12px',
              minHeight: '32px',
              py: '8px',
              px: '12px',
              minWidth: 0,
              '&:hover': {
                bgcolor: type === 'titularidade' ? 'white' : '#E0E0E0',
              },
            }}
          />
        </Tabs>
      </Box>

      <Typography variant="h4" component="h1" sx={{ fontWeight: 500, mb: 1, fontSize: '24px' }}>
        {type === 'envio' && 'Lista de contrapartes para o envio de recursos'}
        {type === 'boleto' && 'Lista de contrapartes para emissão de boletos'}
        {type === 'titularidade' && 'Lista de contas da minha titularidade'}
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ fontSize: '16px' }}>
        {type === 'envio' && 'Gerencie suas contrapartes para o envio de recursos'}
        {type === 'boleto' && 'Gerencie suas contrapartes e configurações de pagamento'}
        {type === 'titularidade' && 'Gerencie suas contas de titularidade'}
      </Typography>
    </Box>
  );
};

export default BeneficiaryPageHeader;
